import { Col, Row } from 'antd';
import { getConfig } from 'config';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { camelToKebabCase } from 'utils/camelToKebabCase';

import CompanyAvatar from 'components/CompanyAvatar';
import { COMPANY } from 'models/company.model';
import { COLOR } from 'styles/styledComponents/color.model';

import * as Styled from './LoginPage.styles';

const LoginPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClickCompany = (company: COMPANY) => () =>
    navigate(`/login/${camelToKebabCase(company)}`);

  return (
    <>
      <Styled.CompanyOptionsTitle>{t('loginPage.chooseYourCompany')}</Styled.CompanyOptionsTitle>
      <Row gutter={[16, 16]}>
        {(Object.values(COMPANY) as COMPANY[]).map((type) => {
          const { name, color, Icon, isActive } = getConfig(type);
          return (
            <Col key={type} xs={12}>
              <Styled.CompanyDetails
                color={color}
                isActive={isActive}
                onClick={isActive ? handleClickCompany(type) : () => {}}
              >
                <CompanyAvatar color={isActive ? color : COLOR.GUNSMOKE} Icon={Icon} />
                {name}
              </Styled.CompanyDetails>
            </Col>
          );
        })}
      </Row>
    </>
  );
};

export default LoginPage;
